import { Title } from "@material-ui/icons";

export default {
  head: [
    {
      name: "NHP Home",
      path: "/",
      active: true,
    },

    {
      name: "Snow Home",
      path: "/webgis-snow",
      active: true,
    },
    {
      name: "Objective",
      path: "/webgis-snow/proj-obj",
    },
    {
      name:'Download Products',
      path:'/nhp-data-download'
    }

    // {
    //     name:"Technical Proposal",
    //     path:"/webgis-snow/tech-prop"

    // },
    // {
    //     name:"Project Team",
    //     path:"/webgis-snow/proj-team"

    // },
    // {
    //     name:"Financial Proposal",
    //     path:"/webgis-snow/fin-prop"
    // }
  ],

  breadCrumbs: [
    {
      name: "menu 1",
      path: "/",
    },
    {
      name: "menu 2",
      path: "/",
    },
    {
      name: "menu 3",
      path: "/",
    },
  ],

  mapSideBar: [
    {
      id: 1,
      name: "Snow Cover",
      displayname: "Snow Cover",
      icon: "stroopwafel",
      active: true,
      hasdefault: true,    
      title:"ihujhjs",
      children: [
        {
          id: 1,
          name: "Daily Snow Cover",
          displayname: "Daily Snow Cover",
          icon: "stroopwafel",
          dateReq: true,
          sliderReq: true,
          ismap: true,
          default: true,
          graphstatus: false,
         // title:"Choose a Date for Displaying Daily Snow Map",
          title:"Click on Calendar to choose a date for displaying  Daily Snow Map",
         

          information:
            "                    Source: Derived from SUOMI-NPP VIIRS <br/>                    Frequency: Daily <br/>                    Data Availability: 2015 onwards <br/>                    Period: January to December                      ",
        },
        {
          id: 2,
          name: "Snow Cover Fraction",
          displayname: "Snow Cover Fraction",
          icon: "stroopwafel",
          title:"Click to choose a date for Fortnightly Snow Cover Fraction(SCF).\nClick on the map to query SCF of corresponding pixel.", 
         
          sliderReq: true,
          ismap: true,

          // "graphstatus":true,
          information:
            "Source: Derived from RS-2 AWiFS <br/>                    Frequency: Fortnightly<br/>                    Data Availability: 2015 onwards <br/>                    Period: January to December                  ",
        },
        // {
        //   id: 31,
        //   name: "Annual Maximum SnowCover",
        //   displayname: "Annual Maximum SnowCover",
        //   icon: "stroopwafel",
        //   dateReq: true,
        //   disabled: true,
        //   sliderReq: true,
        //   ismap: true,
        //   // "default":true,
        //   graphstatus: false,
        //   information:
        //     "Source: Derived from RS-2 AWiFS <br/>   Frequency: Daily <br/>   Data Availability: 2015 onwards <br/>    Period: January to December  ",
        // },
        // {
        //   id: 41,
        //   name: "Annual Minimum SnowCover",
        //   displayname: "Annual Minimum SnowCover",
        //   icon: "stroopwafel",
        //   dateReq: true,
        //   sliderReq: true,
        //   ismap: true,
        //   // "default":true,
        //   disabled: true,
        //   graphstatus: false,
        //   information:
        //     "Source: Derived from RS-2 AWiFS <br/>   Frequency: Daily <br/>   Data Availability: 2015 onwards <br/>    Period: January to December  ",
        // },
        // {
        //   id: 51,
        //   name: "Snow Cover Persistence                    ",
        //   displayname: "Snow Cover Persistence",
        //   icon: "stroopwafel",
        //   dateReq: true,
        //   sliderReq: true,
        //   ismap: true,
        //   // "default":true,
        //   disabled: true,
        //   graphstatus: false,
        //   information:
        //     "Source: Derived from RS-2 AWiFS <br/>   Frequency: Daily <br/>   Data Availability: 2015 onwards <br/>    Period: January to December  ",
        // },
      ],
    },

    {
      id: 2,
      name: "Spatial Snowmelt",
      displayname: "Spatial Snowmelt Rate",
      active: false,
      icon: "stroopwafel",
      forecast: true,
      children: [
        {
          id: 1,
          name: "Forecast",
          //name:"Forecast Snowmelt Rate",
          title:"Choose a Date for 3 –day Forecast Product. Click on the map to see the pixel-wise melt rates",
          displayname: "Snowmelt Rate Forecast (3days)",
         
          icon: "stroopwafel",
          default: true,
          issub: true,
          dateReq: true,
          sliderReq: true,
          information:
            "Source: Modelled from Suomi-NPP, INSAT-3D/3DR satellite derived products and GEFS forecast data <br/>                        Frequency: Daily <br/>                        Forecast period: T+3 days<br/>                        Data Availability: 2019 onwards     <br/>                   Period: April to June                       ",
        },
        {
          id: 2,
          name: "Actual",
          //name: "Daily Snowmelt Rate",

          displayname: "Daily Snowmelt Rate (Potential)",
          title:"Choose a Date for Daily Snowmelt rate Product. Click on the map to see the pixel-wise melt rate",
          icon: "stroopwafel",
          ismap: true,
          dateReq: true,
          sliderReq: true,
          information:
            "Source: Modelled from Suomi-NPP, INSAT-3D/3DR satellite derived products and GEFS data <br/>                        Frequency: Daily<br/>                        Data Availability: 2019 onwards<br/>                        Period: April to June                                   ",
        },
      ],
    },

    // {
    //   id: 5,
    //   name: "Snowmelt Runoff Forecast",
    //   displayname: "Snowmelt Runoff Forecast (MCM)",
    //   active: false,
    //   enabled:false,
    //   icon: "stroopwafel",
    //   children: [
    //    {
    //       id: 8,
    //        name: "Snowmelt Runoff Forecast ",
    //        displayname: "Snowmelt Runoff Forecast(T+3days)",
    //        icon: "stroopwafel",
    //        dateReq: true,
    //        collapsed: false,
    //        sliderReq: true,
    //        ismap: true,
    //        active: false,
    //       // default:true,
    //        information:
    //          "Source: Modelled from Suomi-NPP, INSAT-3D/3DR satellite derived products and GEFS forecast data <br/>                        Frequency: Daily <br/>                        Forecast period: T+3 days<br/>                        Data Availability: 2019 onwards     <br/>                   Period: April to June                       ",
    //      },
    //      {
    //       id: 9,
    //        name: "Daily Snowmelt Runoff",
    //        displayname: "Daily Snowmelt Runoff (Potential)",
    //        icon: "stroopwafel",
    //        collapsed: false,
    //        dateReq: true,
    //        active: false,
    //        sliderReq: true,
    //        ismap: true,
    //        information:
    //          "Source: Modelled from Suomi-NPP, INSAD-3D/3DR satellite derived products and GEFS forecast data <br/>                        Frequency: Daily <br/>                        Forecast period: T+3 days<br/>                        Data Availability: 2019 onwards     <br/>                   Period: April to June                       ",
    //      },
    //     ],
    //   },

    
    //     // {
    //     //     "id": 3,
    //     //     "name": 3,
    //     //     "icon":"stroopwafel",
    //     //     "ismap":true,

    //     // }
    //   ],
    // },

    // {
    //     "id": 4,
    //     "name": 'Spatial Snowmelt  Data',
    //     "icon":"stroopwafel",
    //     "dateReq":true,
    //     "ismap":true,

    // },

    // {
    //     "id": 3,
    //         "name": 'Base Layers',
    //         "icon":"stroopwafel",
    //         "hasdefault":true,
    //         "children": [
    //             {
    //                 "id": 1,
    //                 "name": 'DEM',
    //                 "icon":"stroopwafel",
    //                 "ismap":true,

    //             },

    //             {
    //                 "id": 2,
    //                 "name": 'Satellite Imagery',
    //                 "icon":"stroopwafel",
    //                 "ismap":true,

    //             },
    //             {
    //                 "id": 3,
    //                 "name": 'River Network',
    //                 "icon":"stroopwafel",
    //                 "ismap":true,

    //             },
    //             {
    //                 "id": 4,
    //                 "name": 'Administrative',
    //                 "icon":"stroopwafel",
    //                 "ismap":true,

    //             },
    //             {
    //                 "id": 5,
    //                 "name": 'Infrastructure',
    //                 "icon":"stroopwafel",
    //                 "ismap":true,

    //             },
    //             {
    //                 "id": 5,
    //                 "name": 'LULC',
    //                 "icon":"stroopwafel",
    //                 "ismap":true,

    //             }
    //             // {

    //             // }
    //         ]
    //     }





    
    //  {
    //     id: 331,
    //        name: 'Comparison Slider',
    //        displayname: 'Comparison Analysis',
    //        icon:"stroopwafel",
    //        sliderReq: true,
    //        ismap: true,
    //         children: [    
              
    //           {/*
    //             id: 1,
    //             name: "Daily Snow Cover",
    //             displayname: "Snow Cover Area",
    //             icon: "stroopwafel",
    //             sliderReq: true,
    //             ismap: true,
    //         */},
    //           {
    //             id: 22,
    //             //name: "Daily Snowmelt Rate",
    //             //displayname: 'Daily Snowmelt Rate',
    //             name: "Actual",
    //             displayname: "Snowmelt Rate (Potential)",
    //             icon:"stroopwafel",
    //             sliderReq: true,
    //             ismap: true,
    //           },
    //           {
    //             id: 23,
    //             name: "Forecast",
    //             displayname: "Snowmelt Rate Forecast",
    //             icon: "stroopwafel",
    //             sliderReq: true,
    //             ismap: true,
                
    //           },
    //           {/*
    //             id: 24,
    //             name: "Snow Cover Fraction",
    //             displayname: 'Snow Cover Fraction',
    //             icon:"stroopwafel",
    //             sliderReq: true,
    //             ismap: true,
    
    //           */ },
              
    //         ]
    //  }
  ],
};

